var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "cafe_item",
      class: _vm.ison,
      on: { mouseover: _vm.activate }
    },
    [
      _c("a", { attrs: { href: _vm.cafe.article.readUrl } }, [
        _c("strong", { staticClass: "tit_info" }, [
          _c("span", { staticClass: "screen_out" }, [_vm._v("글제목")]),
          _vm._v(_vm._s(_vm.cafe.article.title.slice(0, 25)))
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "txt_name" }, [
          _c("span", { staticClass: "screen_out" }, [_vm._v("카페명")]),
          _vm._v(_vm._s(_vm.cafe.cafe.name.slice(0, 20)))
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }